import { Backdrop, Box, Button, CircularProgress, List, MenuItem, Select, Typography, useMediaQuery, useTheme } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { branchlist, submitComplaint } from '../../feature/api/Complaint';
import { useDispatch, useSelector } from 'react-redux';

import DatePicker from "react-multi-date-picker"
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa";

const NewComplaint = () => {
    const theme = useTheme()
    const phone = useMediaQuery(theme.breakpoints.between(280,830))
    const dispatch = useDispatch()
    const branches = useSelector(state => state.complaint.branches)
    const isLoadingSubmit = useSelector(state => state.complaint.isLoadingSubmit)

    const [name,setName] = useState()
    const [fishNum,setFishNum] = useState()
    const [date,setDate] = useState()
    const [mobile,setMobile] = useState()
    const [text,setText] = useState()
    const [branch,setBranch] = useState()
    
    useEffect(() => {
      dispatch(branchlist())
    }, [])
    
    
    const handleForm  = (e) => {
        e.preventDefault()
        if(branch && name && mobile && fishNum && date && text){
            dispatch(submitComplaint({
                  mobile:mobile,
                  Name : name,
                  branch:branch,
                  fishNum:fishNum,
                  date:date,
                  description:text  
            }))

        }

    }
  return (
    <Box display={"flex"} flexDirection={"column"} gap={2}>
        <Typography fontSize={"20px"} fontWeight={900} color="#dc7200">ثبت و ایجاد شکایت / درخواست جدید</Typography>
        <Typography variant='body2' color={'#fff'} textAlign={"justify"}>مشتری گرامی ضمن عرض پوزش بابت مشکل به وجود آمده، خواهشمندیم جهت ارسال شکایات خود و ارتباط مستقیم با واحد CRM جان اسنک لطفا فرم زیر را تکمیل نمایید. بلافاصله پس از دریافت فرم توسط جان اسنک بررسی آن آغاز شده و نتیجه آن از طریق شماره تماس شما به اطلاع خواهد رسید.</Typography>
        <Box component={"ul"}>
            <Typography variant='body2' component={"li"} color={'#fff'} >
                اخذ مشخصات فردی و شماره تماس صرفا جهت دسترسی و پیگیری های بعدی می باشد و در صورت عدم تكمیل این موارد امكان پیگیری و دریافت پاسخ وجود ندارد.
            </Typography>
            <Typography variant='body2' component={"li"} color={'#fff'}>
                پس از تکمیل فرم، کد رهگیری صادر شده از سوی سیستم را جهت پیگیری های بعدی نگهداری فرمایید.
            </Typography>
            <Typography variant='body2' component={"li"} color={'#fff'}>
                در صورت ثبت شماره موبایل، کد رهگیری از طریق پیامک به شماره ثبت شده ارسال می گردد.
            </Typography>
            <Typography variant='body2' component={"li"} color={'#fff'}>
                لطفا شماره شعبه و یا نام شهر و منطقه شعبه مورد نظر را درج نمایید.
            </Typography>
            <Typography variant='body2' component={"li"} color={'#fff'}>
                ثبت زمان خرید و همچنین شماره فیش منوی خریداری شده به سرعت در بررسی و اعلام نتیجه کمک شایانی خواهد نمود.
            </Typography>
        </Box>
        <Box component={"form"} display={"flex"} flexDirection={"column"} gap={2} onSubmit={handleForm}>
            <input type="text" value={name} onChange={e => setName(e.target.value)} placeholder='نام و نام خانوادگی' style={{color:'#fff',width:'100%', border:'1px solid #dc7200',backgroundColor:'inherit',padding:'10px',borderRadius:'30px'}} />
            <input type="tel" value={mobile} onChange={e => setMobile(e.target.value)} placeholder=' شماره موبایل ' style={{color:'#fff',width:'100%', border:'1px solid #dc7200',backgroundColor:'inherit',padding:'10px',borderRadius:'30px'}} />
            <DatePicker
                containerStyle={{width:'100%',borderRadius:'30px'}}
                style={{width:'100%',padding:'20px',fontSize:'1rem',borderRadius:'30px',border:'1px solid #dc7200',backgroundColor:'inherit',color:'#fff'}}
                
                calendar={persian}
                locale={persian_fa}
                calendarPosition="bottom-right"
                // value={info.BirthDay}
                // currentDate={info.BirthDay}
                // onChange={setDatePicker}
                placeholder={"تاریخ ثبت سفارش"}
                onChange={e => setDate(e?.year + "/" + ((e?.month?.number).toString().length === 1 ? "0"+ (e?.month?.number).toString() :e?.month?.number)  + "/" + ((e?.day)?.toString().length === 1 ? "0" + e?.day : e?.day))}
                value={date}
                 
              /> 
              <Select
              //  value={}  
               placeholder=' شعبه مورد نظر ' 
               size='small'
               style={{color:'#fff',width:'100%', border:'1px solid #dc7200',backgroundColor:'inherit',borderRadius:'30px'}}
               defaultValue={0}
               MenuProps={{dir:'rtl'}}
              >
                <MenuItem value={0}  selected disabled>شعبه مورد نظر</MenuItem>

                {branches?.map((item)=>
                <MenuItem value={item.branch}  onClick={()=>{
                    setBranch(item.RealBranch)
                }} >{`شعبه ${item.branch} ${item.location}`}</MenuItem>
                )}

              </Select>
            <input type="tel"  value={fishNum} onChange={e => setFishNum(e.target.value)} placeholder=' شماره فیش ' style={{color:'#fff',width:'100%', border:'1px solid #dc7200',backgroundColor:'inherit',padding:'10px',borderRadius:'30px'}} />
            <textarea type="text" value={text} onChange={(e) => setText(e.target.value)} placeholder='متن شکایت' style={{height:'200px',color:'#fff',width:'100%', border:'1px solid #dc7200',backgroundColor:'inherit',padding:'10px',borderRadius:'20px'}} />
            <Button type='submit'  sx={{bgcolor:'#dc7200',borderRadius:'20px'}} variant='contained'>ارسال</Button>
        </Box>
        <Backdrop
				sx={{ color:'#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
				open={isLoadingSubmit}
		>
					<CircularProgress color="inherit" />
		</Backdrop>
    </Box>
  )
}

export default NewComplaint